import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
} from "../../actionTypes/auth";
import Auth from "../../../services/api/auth";

// onSuccess handler for dashboard data api
const onLoginSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});

// onFail handler for dashboard data api
const onLoginFail = (payload) => ({
  type: LOGIN_FAIL,
  payload,
});

/**
 * This function handles the dashboard data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* initiateLogin(action) {
  try {
    const response = yield call(Auth.login, action.payload);
    console.log("login response :", response);
    localStorage.setItem("authToken", response.headers["x-auth-token"]);
    localStorage.setItem("loginId", response.headers["login-id"]);
    yield put(onLoginSuccess(true));
  } catch (error) {
    yield put(onLoginFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for Auth
 */
function* watchAuthSaga() {
  yield takeLatest(INITIATE_LOGIN, initiateLogin);
}
export default watchAuthSaga;
